// @flow
/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import { JsonForms } from '@jsonforms/react';

import renderers from './renderers';
import useParseMetadata from './utils/useParseMetadata';
import { generateKeyFromId } from './utils/parseMetadata';

type Props = {
    value: $FixMe,
    i18n: $FixMe,
    metadata: $FixMe,
    onChange: (data, errors) => void
};

const Form = ({ value, i18n, onChange, metadata }: Props): React.Node => {
    const _i18n = React.useMemo(() => {
        return {
            locale: i18n.locale,
            translate: (id, defaultValue) => {
                if (!defaultValue) {
                    return;
                }
                const key = generateKeyFromId(id);
                return i18n.translate(key, defaultValue);
            },
            translateError: error => {
                // TODO: i18n support for all error messages
                if (
                    error.keyword === 'required' &&
                    error.message?.startsWith('must have required property')
                ) {
                    return 'is a required property';
                }
                return error.message;
            }
        };
    }, [i18n]);

    const { schema, uiSchema } = useParseMetadata(metadata);

    return (
        <JsonForms
            schema={schema}
            uischema={uiSchema}
            data={value}
            renderers={renderers}
            i18n={_i18n}
            onChange={({ data, errors }) => {
                // console.log({ data, errors });
                onChange(data, errors);
            }}
        />
    );
};

export default Form;
